import { Listing, Seller } from "@prisma/client";
import React from "react";
import { LuInstagram, LuList, LuLock, LuPhone } from "react-icons/lu";
import Image from "next/image";
import { FaWhatsapp } from "react-icons/fa";
import { useRouter } from "next/router";
import { useTranslations } from "@/TranslationContext";
import StatsHelper from "@/utils/StatsHelper";
import CommonUtils from "@/utils/CommonUtils";
import Link from "next/link";

const MiniSellerProfile = ({
  listing,
  seller,
  whatsAppText,
  userIsAdmin = false,
}: {
  seller: Seller;
  listing?: Listing;
  whatsAppText: string;
  userIsAdmin: boolean;
}) => {
  let imagePath = CommonUtils.getDPImagePath(seller.thumbnail_path);

  const router = useRouter();
  const t = useTranslations();

  const { locale } = router;

  const ls = locale === "sw" ? "" : `/${locale}`;

  return (
    <div className="text-center mx-3">
      <div className="text-center space-y-6 mt-5">
        <Image
          src={imagePath}
          alt={seller.name}
          className=" w-16 aspect-square rounded-full border-2 border-white shadow-sm mx-auto"
          width={40}
          height={40}
          title={seller.name}
        />
        <h6 className="mt-5 font-bold text-gray-600">{seller.ig_name}</h6>
        <span className="text-slate-600 text-sm mt-2">{seller.name}</span>
        <div className="space-y-4">
          <div className="flex space-x-2">
            <Link
              href={"tel:" + seller.phone}
              target="_blank"
              className="btn bg-green-600 hover:bg-green-700 text-white rounded-md text-sm flex-1"
              onClick={() => {
                StatsHelper.registerProfileButtonsClick(
                  listing.id,
                  seller.id,
                  "seller_call_btn_click"
                );
              }}
              title={t.call}
            >
              <LuPhone className="icon mr-2" />
              {t.call}
            </Link>
          </div>
          <div className="flex space-x-2">
            <Link
              href={`https://wa.me/${seller.whatsapp_number}?text=${whatsAppText}`}
              target="_blank"
              className="btn bg-[#138c7e] hover:bg-[#075e54] text-white rounded-md text-sm flex-1"
              onClick={() => {
                StatsHelper.registerProfileButtonsClick(
                  listing.id,
                  seller.id,
                  "seller_whatsapp_btn_click"
                );
              }}
              title={t.whatsapp}
            >
              <FaWhatsapp className="icons mr-2" />
              WhatsApp Chat
            </Link>
          </div>
          <div className="flex space-x-2">
            <Link
              href={"https://instagram.com/" + seller.ig_id}
              target="_blank"
              className="btn border-2 text-blue-500 border-blue-500 hover:bg-blue-500 hover:text-white  rounded-md flex-1"
              onClick={() => {
                StatsHelper.registerProfileButtonsClick(
                  listing.id,
                  seller.id,
                  "seller_ig_profile_btn_click"
                );
              }}
              title={t.instagram}
            >
              <LuInstagram className="icons mr-2" />
              Instagram Profile
            </Link>
          </div>
          <div className="flex space-x-2">
            <Link
              href={`${ls}/listings?seller=${seller.uuid}`}
              className="btn border-2 text-gray-600 border-gray-600 hover:bg-black hover:text-white  rounded-md flex-1"
              onClick={() => {
                StatsHelper.registerProfileButtonsClick(
                  listing.id,
                  seller.id,
                  "seller_posts_btn_click"
                );
              }}
              title={t.instagram}
            >
              <LuList className="icons mr-2" />
              View posts
            </Link>
          </div>
          {userIsAdmin && (
            <div className="flex space-x-2">
              <Link
                href={`${ls}/app-admin/login-as-seller/${seller.uuid}`}
                className="btn border-2 text-gray-600 border-gray-600 hover:bg-black hover:text-white  rounded-md flex-1"
              >
                <LuLock className="icons mr-2" />
                Login as seller
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MiniSellerProfile;
